/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useEffect, useState } from 'react';
import Spinner from '../../assets/UW_Horizontal_Logo_Full.png';

import './FullPageLoader.css';

const FullPageLoader = () => {

    const quotes = [
        "Happiness is not just a place, but also a process.", //Ed Diener
        "It is not primarily our physical selves that limit us but rather our mindset about our physical limits.", //Ellen J. Langer
        "Happiness is the only thing that multiplies when you share it.", //Albert Schweitzer
        "Becoming is better than being.", //Carol S. Dweck
        "Our wounds are often the openings into the best and most beautiful part of us.", //David Richo
        "Happiness cannot be pursued; it must ensue.", //Viktor E. Frankl
        "It's a wonderful thing to be optimistic. It keeps you healthy and it keeps you resilient.", //Daniel Kahneman
        "Who looks outside, dreams; who looks inside, awakes.", //Carl Jung
        "A strong, positive self-image is the best possible preparation for success.", //Joyce Brothers
        "Life itself still remains a very effective therapist." //Karen Horney
    ];

    const [quoteToDisplay, setQuoteToDisplay] = useState(quotes[Math.floor(Math.random() * quotes.length)]);

    useEffect(() => {
        if (document.getElementById("root").firstElementChild.id !== 'loaderDiv') {
            document.getElementById("root").classList.value = "";
            document.getElementById("root").firstElementChild.firstElementChild.classList.value = "firstChildDiv";
            document.getElementById("root").firstElementChild.classList.value = "firstChildDiv";
        }
        return () => {
            if (document.getElementById("root").firstElementChild.id !== 'loaderDiv') {
                document.getElementById("root").classList.value = "container container-fluid";
                document.getElementById("root").firstElementChild.firstElementChild.classList.value = "";
                document.getElementById("root").firstElementChild.classList.value = "";
            }
        };
    }, [])

    // const [loading, setLoading] = useState(false);

    // return [
    //     loading ?
    //     <div style={{position:'fixed', width:'100%', height:'100%', top:0, left:0, background:"rgba(255,255,255,0.6)"}}>
    //         <img width="100%" height="100%" src={Spinner} alt="loading" />
    //     </div>
    //     :null,
    //     () => setLoading(true),
    //     () => setLoading(false)
    // ]
    return (
        <div id="loaderDiv" className="mx-auto d-flex flex-column align-items-center justify-content-center">
            <img height="auto" width="50%" src={Spinner} />
            <div className='mt-2 text-center' style={{ fontSize: "1.4rem", fontWeight: "600" }}>{quoteToDisplay}</div>
            <div className='mt-2 text-center' style={{ fontSize: "1.4rem", fontWeight: "600" }}>Loading...</div>
            {/* <div className='mt-2 text-center' style={{ fontSize: "1.4rem", fontWeight: "600" }}>We are almost there, please give us a moment.</div> */}
        </div>
    )
}

export default FullPageLoader;